const Constants = {
    KEY_TOKEN: 'token',
    KEY_USER_LOGGED_IN: 'userLoggedIn',
    KEY_IS_LEARNER: 'isLearner',
    KEY_IS_PROGRAM_MANAGER: 'isProgramManager',
    KEY_PROFILE_PIC: 'profilePic',
    KEY_USERNAME: 'username',
    KEY_FULL_NAME: 'fullName',
    KEY_EMAIL: 'email',
    KEY_PHONE_NUMBER: 'phone',
    KEY_USER_ID: 'userId',
    KEY_PASSWORD: 'password',
    REGEX_PASSWORD_VALIDITY: /^[\w\_\.\@\#\$]{8,32}$/,
    REGEX_EMAIL_VALIDITY: /^(?:\w+)(?:[.-][\w]+)*@(?:\w+)(?:[.-][\w]+)*(\.\w{2,3})$/,
    REGEX_URL_VALIDITY: /(https?:\/\/(?:www\.)?[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,})/,
    MAX_CHAR_FOR_USERNAME: 24,

    // FIREBASE_STUDENT_ATTENDANCE_LOGS_URL: 'https://classroom-logs-6dce4-default-rtdb.asia-southeast1.firebasedatabase.app/students-session-recording-attendance.json',
    // FIREBASE_CLASSROOM_LOGS: 'https://classroom-logs-6dce4-default-rtdb.asia-southeast1.firebasedatabase.app/',

    FIREBASE_STUDENT_ATTENDANCE_LOGS_URL: 'https://classroom-notifications-ae74c-default-rtdb.asia-southeast1.firebasedatabase.app/students-session-recording-attendance.json',
    FIREBASE_CLASSROOM_LOGS: 'https://classroom-notifications-ae74c-default-rtdb.asia-southeast1.firebasedatabase.app/',

    KEY_CERTIFICATION_DATA: 'certificationData',
    KEY_PAYMENT_AMOUNT: 'kpa',
    KEY_FORM_DATA: 'formData',
    KEY_FORM_DATA_OBJECT: 'formDataObject',
    KEY_CERTIFICATION_CODE: 'certificationCode',
    KEY_LEARNER_BADGE: 'learnerBadge',
    KEY_RCRM_TOKEN: "41ARPtNpNOWMmESE73EwgZfSMWPR-8R4XxqcFeYGs-C1pMww18M-r2t8Q36xP6k7rircBOl8nmzR5NW9KXqUQ18xNTk1NTg4MDAz",
    KEY_CANDIDATE_SLUG: "candidateSlug",
    KEY_PLACEMENT_ASSISTANCE_SLUG: "kplaceassist",
    KEY_PROGRAM_STRIP: "kpstp",
    UNIVERSITY_HOMEPAGE: "https://university.edyoda.com/?utm_source=ClassroomTopbar&utm_medium=ClassroomTopbar&utm_campaign=ClassroomTopbar&utm_id=ClassroomTopbar&programCardsSection=true",
    FIREBASE_CAREER_TRACKS_PAGE_LOGS: 'https://classroom-notifications-ae74c-default-rtdb.asia-southeast1.firebasedatabase.app/career-tracks-page-logs.json',
    MOBILE_NUMBER: '+91 8971554184'
}

Object.freeze(Constants);
export default Constants;